import * as CONSTANTS from "../../utilities/Constants";
import { IGradeBasicData, defaultGradeBasicData } from "../grade/GradeBasicData";
import { IKeyedInPropertyData } from "../shared/IKeyedInPropertyData";
import { IMeasuredPropertyData } from "../shared/IMeasuredPropertyData";
import { ICalculatedPropertyData } from '../shared/ICalculatedPropertyData';
import moment from "moment";
import DateFormatting from "../../utilities/DateFormat";

export interface IProductViewData {
    id: string;
    name: string;
    description: string;
    grade: IGradeBasicData;
    code: string;
    isEnabled: boolean;
    state: string;
    measuredProperties: IMeasuredPropertyData[];
    keyedInProperties: IKeyedInPropertyData[];
    calculatedProperties: ICalculatedPropertyData[];
    createdOn?: string;
    formatedDate?: string;
  }
  

  
  export default class ProductViewData implements IProductViewData {
    id: string;
    name: string;
    description: string;
    grade: IGradeBasicData;
    code: string;
    isEnabled: boolean;
    state: string;
    measuredProperties: IMeasuredPropertyData[];
    keyedInProperties: IKeyedInPropertyData[];
    calculatedProperties: any[];
  
    descriptionLabel: string;
    gradeNameLabel: string;
    codeLabel: string;
    stateLabel: string;
    createdOn?: string;
    formatedDate?: string;

    constructor(id: string, name: string, description: string, grade: IGradeBasicData,
        code: string,
        isEnabled: boolean,
        measuredProperties: IMeasuredPropertyData[],
        keyedInProperties: IKeyedInPropertyData[],
        calculatedProperties: any[],
        createdOn?: string
        ) {
      this.id = id;
      this.name = name;
      this.description = description;
      this.grade = grade;
      this.code = code;
      this.isEnabled = isEnabled;
      this.measuredProperties= measuredProperties;
      this.keyedInProperties= keyedInProperties;
      this.calculatedProperties= calculatedProperties;

  
      this.descriptionLabel = "Description";
      this.gradeNameLabel = "Grade";
      this.codeLabel = "Product Code";
      this.stateLabel = "State";

      this.state = id !== '' ? isEnabled ? CONSTANTS.ENABLED : CONSTANTS.DISABLED :'';
      this.createdOn = createdOn
      ? moment.utc(createdOn)
      .utcOffset(DateFormatting.getDateTimeRegionOffset())
      .format(DateFormatting.getDateTimeRegion())
      : createdOn;
    this.formatedDate = createdOn
      ? moment.utc(createdOn)
      .utcOffset(DateFormatting.getDateTimeRegionOffset())
      .format(DateFormatting.getDateTimeRegion())
      : createdOn;
    }
  }
  
  const defaultProductData = new ProductViewData("", "", "", defaultGradeBasicData, "", true, [],[],[]);
  export {defaultProductData};
  